/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

export type CloudStorageItemType =
  (typeof CloudStorageItemType)[keyof typeof CloudStorageItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloudStorageItemType = {
  document: 'document',
  chat: 'chat',
  project: 'project',
} as const;
